import { Component } from 'react'
import { diffWords } from 'diff'
import { Button, Input, Row, Col, Card  } from 'antd'
import './css/App3.css'

class Demo extends Component {
    state = {
        oldText: '',
        newText: '',
        diffResult: '',
        onlyOldText: '',
        onlyAddedText: '',
        ids: [],
        colors: []
    }

    handleCompare = async() => {
        try {
            // json文本逐个比较处理
            let oldText = JSON.parse(this.state.oldText)
            let newText = JSON.parse(this.state.newText)
            let tong = []
            let yi = []
            Object.keys(oldText).forEach((key,i) => {
                if (newText.hasOwnProperty(key)) {
                    tong.push(key)
                }
            })
            tong.forEach(key => {
                if (!newText.hasOwnProperty(key)) {
                    yi.push(key)
                }
            })
            const orderedMap = new Map()
            tong.forEach(key => {
                orderedMap.set(key, newText[key])              
            })
            yi.forEach(key => {
                orderedMap.set(key, newText[key])       
            })
            await this.setState({
                oldText: JSON.stringify(oldText,null,2),
                newText: JSON.stringify(Object.fromEntries(orderedMap),null,2)  
            })
        } catch {
            console.log('新旧文本至少有一个不是json 。。。。。。。。。。。。。。')
        }
        // console.log(this.state.oldText)
        // console.log(this.state.newText)

        const diff = diffWords(this.state.oldText, this.state.newText)

        // 生成完整的对比结果（删除的红色删除线，新增的绿色）
        let ids = []
        let colors = []
        let formattedDiff = diff?.map((part, index) => {
            if (part.removed) {
                ids.push('fff'+index)
                colors.push('red')
                return (
                    <span key={index} id={'fff'+index} style={
                        { textDecoration: 'line-through', backgroundColor: '#ffdddd', color: 'red' }}>
                        {part.value}
                    </span>
                )
            } else if (part.added) {
                ids.push('fff'+index)
                colors.push('green')
                return (
                    <span key={index} id={'fff'+index} style={
                        { backgroundColor: '#ddffdd', color: 'green' }}>
                        {part.value}
                    </span>
                )
            }
            return part.value
        })
        // 仅保留删除标记的文本，去掉新增部分
        let filteredTextWithoutAdded = diff?.map((part, index) => {
            if (part.removed) {
                return (
                    <span key={index} style={
                        { textDecoration: 'line-through', backgroundColor: '#ffdddd', color: 'red' }}>
                        {part.value}
                    </span>
                )
            } else if (!part.added) {
                return part.value // 其他部分正常显示
            }
            return '' // 去掉新增的部分
        })
        // 生成去除删除部分的文本，保留未改变和新增的部分
        let filteredTextWithoutRemoved = diff?.map((part, index) => {
            if (part.added) {
                return (
                    <span key={index} style={
                        { backgroundColor: '#ddffdd', color: 'green' }}>
                        {part.value}
                    </span>
                )
            } else if (!part.removed) {
                return part.value
            }
            return ''
        })
        await this.setState({
            diffResult: formattedDiff,
            onlyOldText: filteredTextWithoutAdded,
            onlyAddedText: filteredTextWithoutRemoved,        
        })
        this.setState({
            ids,
            colors
        })
    }
    scrollToAnchor = (anchorName) => {
        if (anchorName) {            
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                anchorElement.style.scrollMarginTop = '70px'
                anchorElement.scrollIntoView()
            }
        }
    }
    render() {       
        return (
            <Row style={{ margin: '0 auto' }}>
                <Col span={21}>
                    <Row>
                        <Col span={12}>
                            <Input.TextArea style={{ lineHeight: '1.2' }} spellCheck='false' placeholder='请输入原来的内容' rows={5} value={this.state.oldText} onChange={(e) => this.setState({ oldText: e.target.value })} />
                        </Col>
                        <Col span={12}>
                            <Input.TextArea style={{ lineHeight: '1.2' }} spellCheck='false' placeholder='请输入新的内容' rows={5} value={this.state.newText} onChange={(e) => this.setState({ newText: e.target.value })} />
                        </Col>
                    </Row>
                    <Row justify='center'>
                        <Button type="primary" onClick={this.handleCompare} style={{ marginTop: '10px' }}>
                            文本对比（左旧右新）
                        </Button>
                    </Row>
                    <div>
                        {/* {this.state.onlyOldText?.length !== 0 && (
                        <Card title="原文本" id={'c1'} style={
                            { marginTop: '20px', fontSize: '16px', lineHeight: '1.5' }}>
                            <div style={
                                { whiteSpace: 'pre-wrap' }}>{this.state.onlyOldText}</div>
                        </Card>
                    )}
                    {this.state.onlyAddedText?.length !== 0 && (
                        <Card title="新文本" id={'c2'} style={
                            { marginTop: '20px', fontSize: '16px', lineHeight: '1.5' }}>
                            <div style={
                                { whiteSpace: 'pre-wrap' }}>{this.state.onlyAddedText}</div>
                        </Card>
                    )} */}
                        {this.state.diffResult?.length !== 0 && (
                            <Card title="对比结果" id={'c3'} style={
                                { marginTop: '20px', fontSize: '16px', lineHeight: '1.5' }}>
                                <div style={
                                    { whiteSpace: 'pre-wrap' }}>{this.state.diffResult}</div>
                            </Card>
                        )}
                    </div>
                </Col>
                <Col span={3}>
                    <Card title="导航" className='daohang' style={{ position: 'fixed', right: '0', top: '70px', width: '10%', textAlign: 'center' }}>
                        {/* {this.state.onlyOldText?.length !== 0 && (<div style={{marginTop: '8px'}}>
                        <Button styles={{defaultBg: '#d9d9d9'}} onClick={() => { this.scrollToAnchor('c1') }}>原文本</Button>
                    </div>)}
                    {this.state.onlyAddedText?.length !== 0 && (<div style={{marginTop: '8px'}}>
                        <Button onClick={() => { this.scrollToAnchor('c2') }}>新文本</Button>
                    </div>)} */}
                        {this.state.diffResult?.length !== 0 && (<div style={{ marginTop: '8px' }}>
                            <Button onClick={() => { this.scrollToAnchor('c3') }}>对比结果</Button>
                        </div>)}
                        <div style={{ marginTop: '8px', paddingLeft: '20px', width: '90%', overflow: 'auto', height: '360px' }}>
                            {this.state.ids.map((item, index) => (
                                <Button shape='circle' style={{ marginRight: '6px', color: this.state.colors[index] }} onClick={() => { this.scrollToAnchor(item) }}>{index + 1}</Button>
                            ))}
                        </div>
                    </Card>
                </Col>    
            </Row>
        )
    }
}

export default Demo